import React, {
  FC,
  ImgHTMLAttributes,
  useEffect,
  useRef,
  useState,
} from "react";
import checkInViewIntersectionObserver from "utils/isInViewPortIntersectionObserver";
import imagenotJpg from "images/imagenot.jpg";
// import PlaceIcon from "./PlaceIcon";

export interface NcImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  containerClassName?: string;
}

const NcImage: FC<NcImageProps> = ({
  containerClassName = "",
  alt = "nc-imgs",
  src = "",
  className = "object-cover w-full h-full",
  ...args
}) => {
  const _containerRef = useRef(null);
  let _imageEl: HTMLImageElement | null = null;

  const [__src, set__src] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const _checkInViewPort = () => {
    if (!_containerRef.current) return;
    checkInViewIntersectionObserver({
      target: _containerRef.current as any,
      options: {
        root: null,
        rootMargin: "0%",
        threshold: 0,
      },
      freezeOnceVisible: true,
      callback: _imageOnViewPort,
    });
  };

  const _imageOnViewPort = () => {
    if (!src) {
      setImageError(true);
      return true;
    }
    _imageEl = new Image();
    if (_imageEl) {
      _imageEl.src = src;
      _imageEl.addEventListener("load", _handleImageLoaded);
      _imageEl.addEventListener("error", _handleImageError);
    }
    return true;
  };

  const _handleImageLoaded = () => {
    setImageLoaded(true);
    setImageError(false);
    set__src(src);
  };

  const _handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
    set__src("");
  };

  useEffect(() => {
    // Reset states when src changes
    setImageLoaded(false);
    setImageError(false);
    set__src("");
    _checkInViewPort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  const renderLoadingPlaceholder = () => {
    return (
      <div
        className={`${className} flex items-center justify-center bg-neutral-200 dark:bg-neutral-6000 text-neutral-100 dark:text-neutral-500`}
      >
        <div className=" skeleton w-full h-full  ">{/* <PlaceIcon /> */}</div>
      </div>
    );
  };

  const renderErrorPlaceholder = () => {
    return (
      <img 
        src={imagenotJpg} 
        className={className} 
        alt="No image available" 
        {...args}
      />
    );
  };

  return (
    <div
      className={`nc-NcImage ${containerClassName}`}
      data-nc-id="NcImage"
      ref={_containerRef}
    >
      {__src && imageLoaded && !imageError ? (
        <img src={__src} className={className} alt={alt} {...args} />
      ) : imageError ? (
        renderErrorPlaceholder()
      ) : (
        renderLoadingPlaceholder()
      )}
    </div>
  );
};

export default NcImage;
